import {optionsToArray} from "@app/utils/CommonUtils";
import {requestCandidateGroups} from "@app/services/CandidateGroupService";

export const callApiSearchSavedList = async (params, callback) => {
    if (params) {
        if (!params.search_conditions) {
            params.search_conditions = {}
        }
    } else {
        params = {search_conditions: {}}
    }

    const res = await requestCandidateGroups(params);
    return callback(res)
}
